import { useEffect } from "react";

const useTotalQuestionIdeas = (
  generatedQuestionsFromSubmitContent,
  setTotalQuestionNumber
) => {
  useEffect(() => {
    if (generatedQuestionsFromSubmitContent) {
      const totalQuestionIdeas =
        (generatedQuestionsFromSubmitContent.response?.questions?.questionset?.mcqs_questions?.questions
          ?.length ||
          generatedQuestionsFromSubmitContent.response?.questions?.questionset?.mcqs_questions
            ?.length ||
          0) +
        (generatedQuestionsFromSubmitContent.questionset?.mcqs_questions
          ?.questions?.length ||
          generatedQuestionsFromSubmitContent.questionset?.mcqs_questions
            ?.length ||
          0) +
        (generatedQuestionsFromSubmitContent.response?.questions?.questionset?.fib_questions?.questions
          ?.length ||
          generatedQuestionsFromSubmitContent.response?.questions?.questionset?.fib_questions?.length ||
          0) +
        (generatedQuestionsFromSubmitContent.questionset?.fib_questions
          ?.questions?.length ||
          generatedQuestionsFromSubmitContent.questionset?.fib_questions
            ?.length ||
          0) +
        (generatedQuestionsFromSubmitContent.response?.questions?.questionset?.true_false_questions
          ?.questions?.length ||
          generatedQuestionsFromSubmitContent.response?.questions?.questionset?.true_false_questions
            ?.length ||
          0) +
        (generatedQuestionsFromSubmitContent.questionset?.true_false_questions
          ?.questions?.length ||
          generatedQuestionsFromSubmitContent.questionset?.true_false_questions
            ?.length ||
          0);
      setTotalQuestionNumber(totalQuestionIdeas);
    }
  }, [generatedQuestionsFromSubmitContent]);
};

export default useTotalQuestionIdeas;
